import apiService from './apiService';

// ALIGNED WITH web_old/src/services/userStatsService.ts::UserStats interface
export interface UserStats {
  currentStreak: number;
  longestStreak: number;
  checkInsThisWeek: number;
  checkInsThisMonth: number;
  totalCheckIns: number;
  lastCheckInDate: string | null;
}

/**
 * Get user wellness statistics
 */
export async function getUserStats(userId?: string): Promise<UserStats> {
  try {
    // apiService.get() already returns response.data.data (direct data)
    // So no need to check result.success && result.data
    const result = await apiService.get<UserStats>('/wellness/stats');
    
    // Return result directly as it's already in UserStats format
    return result;
  } catch (error) {
    console.error('Error fetching user stats:', error);
    // ALIGNED WITH web_old: Return default stats matching web_old format
    return {
      currentStreak: 0,
      longestStreak: 0,
      checkInsThisWeek: 0,
      checkInsThisMonth: 0,
      totalCheckIns: 0,
      lastCheckInDate: null,
    };
  }
}

/**
 * ALIGNED WITH web_old: Helper function to get formatted streak message
 */
export function getStreakMessage(streak: number): string {
  if (streak === 0) return "Start your streak!";
  if (streak === 1) return "1 day streak";
  return `${streak} days streak`;
}

/**
 * ALIGNED WITH web_old: Helper function to get formatted weekly check-ins message
 */
export function getWeeklyCheckInsMessage(count: number): string {
  if (count === 0) return "No check-ins this week";
  if (count === 1) return "1 check-in this week";
  return `${count} check-ins this week`;
}

/**
 * ALIGNED WITH web_old: Helper function to get formatted monthly check-ins message
 */
export function getMonthlyCheckInsMessage(count: number): string {
  if (count === 0) return "No check-ins this month";
  if (count === 1) return "1 check-in this month";
  return `${count} check-ins this month`;
}

/**
 * ALIGNED WITH web_old: Helper function to get encouragement message based on stats
 */
export function getEncouragementMessage(stats: UserStats): string {
  if (stats.currentStreak === 0) {
    return "Ready to start a new streak? 🚀";
  }
  
  if (stats.currentStreak >= 7) {
    return "Amazing consistency! Keep it up! 🔥";
  }
  
  if (stats.currentStreak >= 3) {
    return "Great momentum! You're on a roll! 💪";
  }
  
  return "Building habits one day at a time! ✨";
}
